import React, { useEffect, createRef } from "react"
import { Button, Modal, Form } from "react-bootstrap"

const ImpersonarModal = (props) => {
  const inputRef = createRef()

  useEffect(() => {
    setTimeout(() => {
      if (inputRef.current) inputRef.current.focus()
    }, 1)
  }, [props.isOpen, inputRef])

  const cerrar = () => {
    props.Cerrar()
  }

  const guardar = () => {
    let usuario = document.getElementById("usuario").value
    let idx = usuario.split("@")[0]
    let tieneArroba = usuario !== idx
    if (tieneArroba) {
      usuario = idx
    }
    props.CambiarUsuario(usuario)
    if (props.Cerrar !== null) {
      props.Cerrar()
    }
  }

  return (
    <div>
      <Modal show={props.show} onHide={cerrar}>
        <Modal.Header>Entrar como otro usuario</Modal.Header>
        <Modal.Body>
          <Form.Control
            type="text"
            innerRef={inputRef}
            name="usuario"
            id="usuario"
            defaultValue=""
            onKeyPress={(event) => {
              if (event.key === "Enter") {
                guardar()
              }
            }}
          ></Form.Control>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={guardar}>
            Entrar
          </Button>
          <Button variant="secondary" onClick={cerrar}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default ImpersonarModal
